const PhotoUpdateModalHOC = props => {
    return props.children;
}

export default PhotoUpdateModalHOC;
